import React, { useCallback, useEffect, useState } from "react";

const Quotes = () => {
  const quotes = [
    {
      name: "Itachi Uchiha",
      role: "Naruto",
      feedback:
        "Each of us lives, dependent and bound by our individual knowledge and awareness. All that is what we call \"reality\". However, both knowledge and awareness are equivocal. One's reality might be another's illusion. We all live inside our own fantasies.",
    },
    {
      name: "Donquixote Doflamingo",
      role: "One Piece",
      feedback:
        "Kids who've never seen peace and kids who have never seen war have different values....",
    },
    {
      name: "Orochimaru",
      role: "Naruto",
      feedback:
        "It's human nature not to realize the true value of something unless they lose it.",
    },
    {
      name: "Piccolo",
      role: "Dragon Ball z",
      feedback:
        "Sometimes, we have to look beyond what we want and do what's the best.",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [animationClass, setAnimationClass] = useState("animate__fadeInRight");

  const handleNext = useCallback(() => {
    setAnimationClass("animate__fadeInRight");
    const nextIndex = (currentIndex + 1) % quotes.length;
    setCurrentIndex(nextIndex);
  }, [currentIndex, quotes.length]);

  const handlePrev = useCallback(() => {
    setAnimationClass("animate__fadeInLeft");
    const prevIndex = (currentIndex - 1 + quotes.length) % quotes.length;
    setCurrentIndex(prevIndex);
  }, [currentIndex, quotes.length]);

  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 7000);
    return () => clearInterval(interval);
  }, [handleNext]);

  return (
    <div className="py-12 px-6 rounded-xl shadow-lg">
      <div
        id="indicators-carousel"
        className="relative w-full max-w-6xl mx-auto"
      >
        <div className="relative overflow-hidden rounded-xl border-2 border-[#94a3b8] bg-[#0f172a] p-6">
          {quotes.map((quote, index) => (
            <div
              key={index}
              className={`${
                index === currentIndex
                  ? `block animate__animated ${animationClass}`
                  : "hidden"
              } duration-700 ease-in-out`}
            >
              <div className="flex flex-col items-center justify-center">
                <div className="text-[#e2e8f0] max-w-3xl text-center">
                  <span className="text-4xl text-[#94a3b8]">
                    <i className="fas fa-quote-left"></i>
                  </span>
                  <p className="mt-4 text-lg md:text-xl font-medium italic px-4 ">
                    {quote.feedback}
                  </p>
                  <div className="mt-8 border-b-2 border-[#94a3b8] w-24 mx-auto"></div>
                  <div className="mt-4">
                    <h3 className="text-xl font-semibold philosopher-6">
                      {quote.name}
                    </h3>
                    <p className="text-[#94a3b8] philosopher-6">{quote.role}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Slider controls */}
        <button
          type="button"
          className="absolute top-1/2 left-4 z-30 flex items-center justify-center w-12 h-12 rounded-full bg-[#0f172a]/80 hover:bg-[#0f172a] transition-all duration-300 group focus:outline-none"
          onClick={handlePrev}
        >
          <svg
            className="w-6 h-6 text-[#e2e8f0] group-hover:text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 6 10"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 1 1 5l4 4"
            />
          </svg>
          <span className="sr-only">Previous</span>
        </button>
        <button
          type="button"
          className="absolute top-1/2 right-4 z-30 flex items-center justify-center w-12 h-12 rounded-full bg-[#0f172a]/80 hover:bg-[#0f172a] transition-all duration-300 group focus:outline-none"
          onClick={handleNext}
        >
          <svg
            className="w-6 h-6 text-[#e2e8f0] group-hover:text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 6 10"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="m1 9 4-4-4-4"
            />
          </svg>
          <span className="sr-only">Next</span>
        </button>
      </div>
    </div>
  );
};

export default Quotes;
